import { useQuery } from '@tanstack/react-query';
import { FieldValues } from 'react-hook-form';

import { projectContributionOptions } from '@/module/Nomen/ProjectContribution/model/ProjectContributionModel';

import { AsyncSelectControl, AsyncSelectControlProps } from '@/core/components';

type ProjectContributionSelectControlProps<T extends FieldValues> = Omit<
  AsyncSelectControlProps<T>,
  'isError' | 'isLoading' | 'options'
>;

export function ProjectContributionSelectControl<T extends FieldValues>(
  props: ProjectContributionSelectControlProps<T>,
) {
  const { data, isLoading, isError } = useQuery(projectContributionOptions.getAll());

  return (
    <AsyncSelectControl
      isError={isError}
      isLoading={isLoading}
      options={data ?? []}
      {...props}
    />
  );
}
